<div #notification class="notification-detail"></div>
